import { useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import Modal from "../../../../parts/modal-new";
import ImgComponent from "../../../../parts/ImgComponent";
import SvgIcon from "../../../../parts/SvgIcon";
import submit from "submit-form";
import getCycleCardImagePath from "../../../../utils/get-cycle-card-image-path";

const TeamInviteModal = ({ locals }) => {
  const { t } = useTranslation(["coaching-portal", "common"]);
  const { activeUserToRequest, teamPrograms, athlete } = locals;
  const { referAsClients } = activeUserToRequest;

  const { name: athleteName, _id: athleteId } = athlete;
  const { published } = teamPrograms;

  const [selectedTeamId, setSelectedTeamId] = useState(null);

  const inviteAthlete = () => {
    const recipients = [athleteId];
    const cycleId = selectedTeamId?._id;
    const currentDateNumber = Number(moment().format("YYYYMMDD"));
    const program = selectedTeamId?.programs?.reduce((prev, prog) => {
      return prog?.startDate <= currentDateNumber &&
        (!prev || prog?.startDate > prev?.startDate)
        ? prog
        : prev;
    }, null);
    const programOrder = program?.order || 1;
    const body = { recipients, cycleId, program: programOrder };

    submit(`/actions/cycle/teams-invite-athletes/${cycleId}`, {
      method: "POST",
      body,
    });
  };

  return (
    <Modal toClear={[]} className="team-invite-modal" title={referAsClients ? t("teams.teamInviteModal.inviteClients") : t("teams.teamInviteModal.inviteAthletes")}>
      <div className="body">
        <div className="flex flex-row mb-4 gap-1">
          <p className="p5">{t("teams.teamInviteModal.selectTeamIntro")}</p>
          <p className="p5 font-bold">{athleteName}</p>
        </div>

        <div className="invite-team-cards-list flex flex-col gap-2">
          {published.length > 0 ? (
            published.map((team) => {
              const memberCount = team.members?.length || 0;
              const startDate = team.programs?.[0]?.startDate;
              const isSelected = selectedTeamId?._id === team._id;

              const image = getCycleCardImagePath(team);

              const imageClassNames = image.startsWith("data:image")
                ? "no-image"
                : "";

              return (
                <article
                  key={team._id}
                  className={`invite-team-card${isSelected ? " selected" : ""}`}
                  onClick={() => setSelectedTeamId(team)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ")
                      setSelectedTeamId(team);
                  }}
                >
                  <div className="invite-team-card-image">
                    <ImgComponent
                      image={image}
                      classNames={imageClassNames}
                      altText="team image"
                    />
                  </div>
                  <div className="invite-team-card-info">
                    <div className="invite-team-card-name">
                      {team.difficulty && (
                        <SvgIcon
                          src={`/img/new-icons/signal-${team.difficulty.toLowerCase()}.svg`}
                          alt="signal"
                          noFilterOnLight={true}
                        />
                      )}
                      <h3>{team.name}</h3>
                    </div>
                    <div className="invite-team-card-detail">
                      <span>{t("teams.teamInviteModal.activeMembers")}</span>
                      <strong>{memberCount}</strong>
                    </div>
                    {startDate && (
                      <div className="invite-team-card-detail">
                        <span>{t("teams.teamInviteModal.startedOn")}</span>
                        <strong>
                          {moment(startDate, "YYYYMMDD").format("MMM D, YYYY")}
                        </strong>
                      </div>
                    )}
                  </div>
                  <div className="invite-team-card-check">
                    <input type="checkbox" checked={isSelected} readOnly />
                  </div>
                </article>
              );
            })
          ) : (
            <div className="flex flex-col gap-2">
              <p className="p5">{t("teams.teamInviteModal.noTeamsFound")}</p>
              <p className="p5">
                {t("teams.teamInviteModal.noTeamsDescription")}
              </p>
            </div>
          )}
        </div>

        <footer className="justify-end!">
          <button
            type="button"
            data-button-type="secondary"
            data-action="cancel"
            onClick={() => {
              window.location.href = "/actions/refresh?modal=";
            }}
          >
            {t("common:cancel")}
          </button>
          <button
            type="button"
            data-button-type="primary"
            disabled={!selectedTeamId}
            onClick={inviteAthlete}
          >
            {t("teams.teamInviteModal.invite")}
          </button>
        </footer>
      </div>
    </Modal>
  );
};
export default TeamInviteModal;
